import { Box, Grid, Typography, styled } from "@mui/material";
import { LongText, SpaceBetweenBox } from "components/GeneralStyled";

import { AcceptWithdrawTextAll } from "./AcceptWithdrawText";
import { DefaultUrlWeb } from "config/Configuration";
import { LoadingButton } from '@mui/lab';
import Modal from "components/Modal";
import NumberFormats from "components/NumberFormats";
import { useFormContext } from "react-hook-form";
import { useParams } from "react-router-dom";

function AcceptWithdrawModal({
  open,
  onClose,
  selectedNetwork,
  selectedCoin,
  receiveAmount,
  onAccept,
  loading
}) {
  const { getValues, watch } = useFormContext();
  const params = useParams();
  const coinDigital = +params?.id;
  const typeId = watch("typeId");
  const isDigital = watch("isDigital");
  const networkId = watch("networkId");
  const { address, proposal, tagOrMemo } = getValues();

  const network = selectedNetwork?.find((n) => n.networkId === networkId);

  return (
    <Modal
      maxWidth={"sm"}
      onClose={onClose}
      open={open}
      title="Withdrawal"
      dir="ltr"
      persistent
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CoinNameWrapper>
            <img
              src={DefaultUrlWeb + selectedCoin?.imageUrl}
              alt={selectedCoin?.name}
            />

            <Typography variant="h5">{selectedCoin?.name}</Typography>
          </CoinNameWrapper>
        </Grid>

        <Grid item xs={12}>
          <SpaceBetweenBox>
            <Typography color="text.secondary" variant="h6">
              Receive Amount
            </Typography>

            <Typography
              textAlign="right"
              component="b"
              color="text.main"
              variant="h5"
            >
              <NumberFormats value={receiveAmount || 0} />{" "}
              <Typography
                variant="subtitle1"
                color="text.secondary"
                component="small"
              >
                {selectedCoin?.name}
              </Typography>
            </Typography>
          </SpaceBetweenBox>

          {address && (
            <SpaceBetweenBox>
              <Typography color="text.secondary" variant="h6">
                Address
              </Typography>

              <LongText
                textAlign="right"
                color="text.main"
                variant="subtitle1"
              >
                {address}
              </LongText>
            </SpaceBetweenBox>
          )}

          {proposal && (
            <SpaceBetweenBox>
              <Typography color="text.secondary" variant="h6">
                Proposal
              </Typography>
              <TypographyProposal
                textAlign="right"
                color="text.secondary"
                variant="subtitle1"
              >
                {proposal}
              </TypographyProposal>
            </SpaceBetweenBox>
          )}

          {tagOrMemo && (
            <SpaceBetweenBox>
              <Typography color="text.secondary" variant="h6">
                Tag or Memo
              </Typography>
              <Typography textAlign="right" color="text.secondary" variant="h5">
                {tagOrMemo}
              </Typography>
            </SpaceBetweenBox>
          )}

          {isDigital && (
            <SpaceBetweenBox>
              <Typography color="text.secondary" variant="h6">
                Network
              </Typography>
              <Typography textAlign="right" color="text.main" variant="h5">
                {network?.networkName}
              </Typography>
            </SpaceBetweenBox>
          )}
        </Grid>

        <Grid item xs={12}>
          <AcceptWithdrawTextAll coinDigital={coinDigital} typeId={typeId} />
        </Grid>

        <Grid item xs={12} mt={2}>
          <LoadingButton variant="contained" loading={loading} fullWidth color="success" onClick={onAccept}>
            Continue
          </LoadingButton>
        </Grid>
      </Grid>
    </Modal>
  );
}

const CoinNameWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  img: {
    marginRight: theme.spacing(1),
    width: "28px",
    height: "28px",
  },
}));

const TypographyProposal = styled(Typography)(() => ({
  width: "50%",
  fontSize: "12px",
  lineBreak: "anywhere",
}));

export default AcceptWithdrawModal;
